import { AxiosInstance } from 'axios'

export const SET_EAP_HPI_BANNER_STATE_IS_LOADED = 'SET_EAP_HPI_BANNER_STATE_IS_LOADED'
export const FETCH_EAP_HPI_BANNER_STATE_FULFILLED = 'FETCH_EAP_HPI_BANNER_STATE_FULFILLED'
export const FETCH_EAP_HPI_BANNER_STATE_REJECTED = 'FETCH_EAP_HPI_BANNER_STATE_REJECTED'

export const fetchEapHpiBannerState = ({
  userLyraId,
  axiosInstance,
}: {
  userLyraId: string
  axiosInstance: AxiosInstance
}) => ({
  action: FETCH_EAP_HPI_BANNER_STATE_FULFILLED,
  request: {
    method: 'get',
    url: `/v1/user/${userLyraId}/eapHpiBannerData`,
    adapter: axiosInstance.defaults.adapter,
    baseURL: axiosInstance.defaults.baseURL,
    headers: axiosInstance.defaults.headers,
  },
  errorHandler: (_error: unknown, dispatch: $TSFixMe) => {
    // Dispatch rejected action to reset state to initial values
    // Cleanly handles state cleanup without triggering error banner
    dispatch({ type: FETCH_EAP_HPI_BANNER_STATE_REJECTED })
  },
})

export const setEapHpiBannerStateIsLoaded = (value: boolean) => ({
  type: SET_EAP_HPI_BANNER_STATE_IS_LOADED,
  payload: value,
})
